import { Modal, Spinner } from 'react-bootstrap';
import { PiWarning } from 'react-icons/pi';
import { useHistory } from 'react-router';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import {
    StyledBodyModal,
    StyledCancelButton,
    StyledConfirmButton,
} from './styles';
import { budgetsDetailRoute } from '../../../../routes/config';
import InvoiceHttpService from '../../../../services/http/invoice-http';
import handleResponseError from '../../../../utils/handleResponseError';

interface Props {
    invoiceCodeItems: string[];
    invoiceId: number;
    onHide: () => void;
}

export default function InvoiceItemsUnavailable({
    invoiceCodeItems,
    invoiceId,
    onHide,
}: Props) {
    const history = useHistory();

    const remakeMutation = useMutation({
        mutationKey: ['remake-invoice'],
        mutationFn: async () =>
            InvoiceHttpService.remake(invoiceId, false, false),
        onError: (error: any) => {
            handleResponseError(
                error,
                'Ocorreu um erro ao refazer o orçamento.',
            );
        },
        onSuccess: (data: any) => {
            toast.success('Orçamento refeito com sucesso');

            history.push(budgetsDetailRoute.build(data.data));
        },
    });

    const handleConfirm = () => {
        if (remakeMutation.isLoading) return;

        remakeMutation.mutate();
    };

    return (
        <StyledBodyModal className="text-center">
            <Modal.Body>
                <PiWarning />
                <Modal.Title>Produtos Indisponíveis</Modal.Title>

                <p className="description">
                    {`Os seguintes produtos não estão mais disponíveis: ${invoiceCodeItems.join(
                        ', ',
                    )}. `}
                </p>

                <p className="description">
                    {`Deseja reprovar esse pedido e criar um novo orçamento
                         sem esses produtos?`}
                </p>

                <div className="d-flex justify-content-center mt-4">
                    <StyledCancelButton onClick={onHide}>
                        Cancelar
                    </StyledCancelButton>
                    <StyledConfirmButton
                        onClick={handleConfirm}
                        disabled={remakeMutation.isLoading}
                    >
                        {remakeMutation.isLoading ? (
                            <Spinner animation="border" />
                        ) : (
                            'Confirmar'
                        )}
                    </StyledConfirmButton>
                </div>
            </Modal.Body>
        </StyledBodyModal>
    );
}
